export const TITLE = 'Password changed successfully';

export const DESCRIPTION = 'You can now log in with your new password';

export const ICON_PROPS = {
  icon: 'send-quote-color',
  size: 104,
  className: 'mb-8',
};
